import React, { useCallback } from 'react'
import MainIcon from '../../../../../img/svg/main'
import { ModalButtonContent, ModalButtonWrap } from '../index.styled'
import InfoMessage from '../../../message/InfoMessage'
import { useWindowBreakPoint } from '../../../../../hooks/useWindowBreakPoint'
import { theme } from '../../../../../style/theme'

const ModalButton = React.memo(({ index, button, isActive, onClick, isDisabled, className }) => {
	const isMobile = useWindowBreakPoint(theme.point820)
	const layout = ((isActive && !isMobile) ? 'active ' : '') + (isDisabled ? 'disabled ' : '') + (className ? `${className} ` : '')

	const handleClick = useCallback((e) => {
		onClick(e, button, index)
	}, [onClick, button, index])

	return (
		<ModalButtonContent>
			<ModalButtonWrap type="button"
											 tabIndex={index}
											 data-testid={button.testId}
											 onClick={handleClick}
											 disabled={isDisabled}
											 className={layout}>
				<MainIcon icon={button.icon} />
				{button.text}
			</ModalButtonWrap>
			{button?.message &&
				<InfoMessage fullWidth={true} center={button.message.center} className="moveUp">{button.message.text}</InfoMessage>}
		</ModalButtonContent>
	)
})

ModalButton.displayName = 'ModalButton'
export default ModalButton
